module.exports = __webpack_public_path__ + "img/118.34808b10.jpg";